<template>
  <el-form
    :model="form"
    label-width="100px"
    :label-position="labelPosition"
    :rules="rules"
  >
    <el-row :gutter="25">
      <el-col :span="24">
        <el-form-item label="Email:" prop="email">
          <el-input v-model="form.email" placeholder="Email" type="email" />
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label="Senha:" prop="password">
          <el-input
            v-model="form.password"
            placeholder="Senha"
            type="password"
            v-on:keyup.enter="LoginUser(form)"
            show-password
          />
        </el-form-item>
      </el-col>

      <el-button type="success" @click="LoginUser(form)">Logar</el-button>
    </el-row>
  </el-form>
</template>


<script lang="ts">
// import AuthService from '../../service/AuthService/AuthService';
import { mapActions } from 'vuex';
// const app = new AuthService();
export default {
  data() {
    const validateEmail = (rule, value, callback) => {
      if (value.includes('@') && value.includes('.com')) {
        callback();
      }
      callback(new Error('Email Invalido'));
    };
    return {
      loading: false,
      labelPosition: 'top',
      form: {
        email: '',
        password: '',
      },
      rules: {
        email: [
          { required: true, message: 'Campo obrigatório', trigger: 'blur' },
          { validator: validateEmail, trigger: 'blur' },
        ],
        password: [
          { required: true, message: 'Campo obrigatório', trigger: 'blur' },
        ],
      },
    };
  },
  methods: {
    ...mapActions('auth', ['login']),
    async LoginUser(form) {
      try {
        this.loading = true;
        await this.login(form).then(() => (this.loading = false));
        this.$router.push('/teacher');
      } catch (error) {
        const menssagem = error.response.data;

        if (error.response.status === 403) {
          const temp = `Seu Cadastro está em ${menssagem.message}`;
          this.ErroNotification(temp);
          // console.log(menssagem.message);
        } else {
          this.ErroNotification(menssagem.message);
        }
      }
    },

    ErroNotification(menssagem) {
      this.$notify.error({
        title: 'Error',
        message: menssagem,
        position: 'bottom-right',
      });
    },
  },
};
</script>

<style>
.el-form-item__label {
  font-size: 15px;
  padding: auto;
}
.el-form-item {
  margin-bottom: 10px;
}
.el-button {
  margin-top: 15px;
  margin-left: 15px;
}
</style>